import { Injectable } from "@angular/core";
import { el, mount } from "src/app/support/dom";
import { createEvents } from "src/app/support/events";

export type IFrameServiceUnMountFn = () => void;

@Injectable()
export class IFrameService {
  private readonly events = createEvents();

  constructor() {
    window.addEventListener("message", (event) => {
      this.events.emit("message", event);
    });
  }

  mount(
    {
      src,
      onMessage,
      onClose
    }: {
      src: string;
      onMessage?: (event: MessageEvent) => void;
      onClose?: () => void;
    },
    {
      height,
      width,
      enableClose
    }: { width: number; height: number; enableClose: boolean }
  ): IFrameServiceUnMountFn {
    const iframe = el("iframe", {
      src,
      class: "border-2 rounded-md z-10 border-slate-600 bg-white",
      style: {
        width: `${width}px`,
        height: `${height}px`
      },
      credentialless: true
    });

    const iframeContainer = el("div", { class: "relative" }, iframe);

    const unsubscribeEvents = this.events.on(
      "message",
      (event: MessageEvent) => {
        if (
          event.source === (iframe as HTMLIFrameElement).contentWindow &&
          !!onMessage
        ) {
          onMessage(event);
        }
      }
    );

    const mountedElement = el(
      "div",
      {
        class:
          "absolute inset-0 flex items-center justify-center p-2 z-10 bg-slate-600/50"
      },
      iframeContainer
    );

    mount(document.body, mountedElement);

    if (enableClose) {
      const closeButton = el(
        "div",
        {
          class:
            "absolute -top-4 -right-4 bg-slate-600 w-8 h-8 flex items-center justify-center rounded-full p-2 cursor-pointer"
        },
        el("div", el("i", { class: "fa-light fa-xmark text-slate-100" }))
      );

      closeButton.addEventListener("click", () => {
        unsubscribeEvents();
        mountedElement.remove();

        if (onClose) {
          onClose();
        }
      });

      mount(iframeContainer, closeButton);
    }

    return () => {
      unsubscribeEvents();
      mountedElement.remove();
    };
  }
}
